import axios from "axios";

const API_URL = "https://zywajdscvz.a.pinggy.link"; // или 8001, если ты его используешь

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 💥 Перехватываем 401 и разлогиниваем
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear(); // Очищаем токен и всё остальное
      window.location.href = "/"; // Редирект на login
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
